(() => {
  if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
  let pending;
  const preload = (source, style = false) => {
    if (!source) return;
    const url = new URL(source, location.origin);
    if (url.protocol !== 'https:') return;
    const rel = style ? 'preload' : 'modulepreload';
    if ([...document.querySelectorAll(`link[rel="${rel}"]`)].some(link => link.href === url.href)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = url.href;
    if (style) link.as = 'style';
    else link.crossOrigin = 'anonymous';
    link.fetchPriority = 'low';
    document.head.append(link);
  };
  const warmup = () => {
    if (pending || !window.WishlistKingAppLoaderURL) return pending;
    pending = import(window.WishlistKingAppLoaderURL).then(({default: loader, appSettings, themeCode = {}}) => {
      const assets = appSettings?.assets;
      if (!assets) return;
      preload(assets.componentWishlistPageBundleJs);
      preload(assets.componentWishlistPageBundleCss, true);
      preload(loader.getSdkUrl('wishlist-element.js'));
      for (const [key, file] of [
        ['wishlistPageJsUrl', 'wishlist-page.js'],
        ['productCardJsUrl', 'wishlist-product-card.js'],
        ['addWishlistToCartJsUrl', 'add-wishlist-to-cart.js'],
        ['addToCartJsUrl', 'add-to-cart.js']
      ]) preload(themeCode[key] || loader.getThemeCodeUrl(file));
    }).catch(() => { pending = null; });
    return pending;
  };
  const onIntent = event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && /\/apps\/wishlist\/?$/.test(url.pathname)) warmup();
  };
  for (const event of ['pointerover', 'pointerdown', 'focusin']) document.addEventListener(event, onIntent, {passive: true});
  const start = () => {
    if (/\/apps\/wishlist(?:\/|$)/.test(location.pathname)) warmup();
    else if (document.querySelector('kf-discovery')) {
      const idle = () => window.requestIdleCallback ? window.requestIdleCallback(warmup, {timeout: 3000}) : setTimeout(warmup, 1200);
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, {once: true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
